import { TextField, createMuiTheme, MuiThemeProvider, Typography, withStyles, Tooltip, TableCell, Snackbar, Switch } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { useEffect, useReducer, useState } from "react";
import Loader from "react-loader-spinner";
import editIcon from '../../assets/edit.png';
import api from "../api";
import MuiAlert from '@material-ui/lab/Alert';
import CloseImage from '../../assets/ic_close.png';
import { useHistory } from "react-router";
import StarOff from '../../assets/starOff.png';
import StarOn from '../../assets/starOn.png';
import Constant from "../../library/Constant";
import { format } from "date-fns";
// import AddMediaDisplay from "./AddMediaDisplay";
// import EditMediaDisplay from "./EditMediaDisplay";


const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptions()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const style = {
    position: "sticky",
    zIndex: 110
};

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 22,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function Ulasan(props) {
    const history = useHistory()
    const [dataTable, setDataTable] = useState([])
    const [id, setID] = useState("")
    const [user, setUser] = useState("")
    const [createdAt, setCreatedAt] = useState(new Date());
    const [newNotes, setNewNotes] = useState("");
    const [visibleCreate, setVisibleCreate] = useState(false)
    const [detail, setDetail] = useState([])
    const [visibleEdit, setVisibleEdit] = useState(false)
    const [visibleDetail, setVisibleDetail] = useState(false)
    const [visibleStatus, setVisibleStatus] = useState(false)
    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);
    const [create, setCreate] = useState(true);
    const [read, setRead] = useState(true);
    const [update, setUpdate] = useState(true);
    const [deleted, setDeleted] = useState(true);
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    useEffect(() => {
        props.setShowNotif(true)
        getDataTable()
    }, [])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const getDataTable = () => {
        api.create().getListUlasan().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data.sort((a, b) => Number(new Date(b.created_at)) - Number(new Date(a.created_at))).map((item, index) => {
                            let tag = []
                            if (item.review_tag !== null) {
                                item.review_tag.map((i) => {
                                    tag.push(i.name)
                                })
                            }
                            return [
                                index + 1,
                                item.user_id,
                                item.name,
                                tag.length > 0 ? tag.join(', ') : '',
                                item.rate,
                                item.comment
                            ]
                        })
                        setDataTable(data)
                    }
                }

            }
        })
    }

    const handleDetail = ({ rowData }) => {
        console.log(rowData);
        setVisibleDetail(true)
        setDetail(rowData)
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    const columns = [
        {
            name: "No",
            options: {
                filter: false,
                sortThirdClickReset: true,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            label: "User ID",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "Nama User",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "",
            label: "Kategori",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "Rating",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <img src={Number(val) >= 1 ? StarOn : StarOff} style={{ width: 20 }} />
                                <img src={Number(val) >= 2 ? StarOn : StarOff} style={{ width: 20 }} />
                                <img src={Number(val) >= 3 ? StarOn : StarOff} style={{ width: 20 }} />
                                <img src={Number(val) >= 4 ? StarOn : StarOff} style={{ width: 20 }} />
                                <img src={Number(val) >= 5 ? StarOn : StarOff} style={{ width: 20 }} />
                            </div>
                        </div>
                    )
                }
            }
        },
        {
            name: "Aksi",
            options: {
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'center', color: '#2a9c6c', fontSize: '12pt', fontWeight: 'bold' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <LightTooltip title={"Detail"} arrow>
                                <button
                                    onClick={() => {
                                        handleDetail(tableMeta)
                                    }}
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }}>
                                    <img src={editIcon} style={{ width: 20, height: 20 }} />
                                </button>
                            </LightTooltip>
                        </div>
                    )
                }
            }
        }
    ];


    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {read && (
                <div >
                    <MuiThemeProvider theme={getMuiTheme()}>
                        <MUIDataTable
                            data={dataTable}
                            columns={columns}
                            options={options}
                        />
                    </MuiThemeProvider>
                </div>
            )}

            {visibleDetail && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Detail Ulasan</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setVisibleDetail(false)
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        <div style={{ textAlign: 'start', width: '100%', margin: 'auto', padding: 30 }}>
                            <TextField
                                // label="Nama User"
                                value={detail.length > 0 ? String(detail[2]).toUpperCase() : "-"}
                                style={{ width: '100%' }}
                                disabled={true}
                                InputProps={{
                                    style: {
                                        fontSize: 15,
                                        fontWeight: 'bold'
                                    },
                                    disableUnderline: true
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                        fontWeight: '500'
                                    }
                                }}
                                inputProps={{
                                    style: {
                                        color: 'black',
                                    }
                                }}
                            />
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '25%', margin: '10px 0' }}>
                                <img src={Number(detail[4]) >= 1 ? StarOn : StarOff} style={{ width: 20 }} />
                                <img src={Number(detail[4]) >= 2 ? StarOn : StarOff} style={{ width: 20 }} />
                                <img src={Number(detail[4]) >= 3 ? StarOn : StarOff} style={{ width: 20 }} />
                                <img src={Number(detail[4]) >= 4 ? StarOn : StarOff} style={{ width: 20 }} />
                                <img src={Number(detail[4]) >= 5 ? StarOn : StarOff} style={{ width: 20 }} />
                            </div>

                            <div style={{ display: 'flex' }}>
                                <Typography>Kategori: </Typography>
                                {detail[3] !== "" && (
                                    <Typography style={{ marginLeft: 10 }}>{detail[3]}</Typography>
                                )}
                            </div>


                            <div >
                                {/* <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 10 }}>Masukan dan Saran</Typography> */}
                                <textarea
                                    disabled
                                    label="Masukan dan Saran"
                                    style={{ width: '100%', marginTop: 10, height: '15vh', fontSize: 14 }}
                                    value={detail.length > 0 ? detail[5] : "-"}
                                // placeholder={"input catatan baru"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}